import * as React from "react";
import { getToken } from "@grandvisionhq/auth";
const useAuthToken = () => {
  const [execute, setExecute] = React.useState(true);
  const [token, setToken] = React.useState(void 0);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(void 0);
  const refreshToken = React.useCallback(() => setExecute(true), []);
  React.useEffect(() => {
    const execAsync = async () => {
      setExecute(false);
      setLoading(true);
      setError(void 0);
      try {
        const result = await getToken();
        if (result?.length) {
          setToken(result);
        }
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          const message = "Unknown error while getting the auth token";
          setError(new Error(message));
          console.error(message, e);
        }
      } finally {
        setLoading(false);
      }
    };
    if (!execute) {
      return;
    }
    execAsync();
  }, [execute]);
  return React.useMemo(
    () => [{ refreshToken }, { loading, data: token, error }],
    [refreshToken, loading, token, error]
  );
};
export {
  useAuthToken as default,
  useAuthToken
};
//# sourceMappingURL=useAuthToken.js.map
